module.exports = __webpack_public_path__ + "img/dianliu2.gif";